// frontend/src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_TITLE = "LuxeSpaces";
const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://luxe-spaces.vercel.app";
const DEFAULT_IMAGE = `${SITE_URL}/images/balcony.jpg`;

export default function SEO({
  title,
  description,
  image,
  url,
  keywords,
  schema,
}) {
  const metaTitle = title ? `${title} | ${SITE_TITLE}` : SITE_TITLE;
  const metaUrl =
    url || (typeof window !== "undefined" ? window.location.href : SITE_URL);
  const metaImage = image || DEFAULT_IMAGE;

  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_TITLE,
    url: SITE_URL,
    logo: `${SITE_URL}/intro-img5.png`,
  };


  const localBusinessSchema = { 
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "FarmerAid - Plant Disease Detection",
  image: `${SITE_URL}/images/og-default.jpg`,
  "@id": SITE_URL,
  url: SITE_URL,
  telephone: "+91-90l4481050", // optional
  address: {
    "@type": "PostalAddress",
    streetAddress: "Tuni, Andhra Pradesh",
    addressLocality: "Tuni",
    addressRegion: "AP",
    postalCode: "533401",
    addressCountry: "IN"
  },
  sameAs: [
    "https://www.facebook.com/farmeraid",
    "https://www.instagram.com/farmeraid"
  ]
}


  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta
          name="keywords"
          content={keywords || "plant disease detection, farming, agriculture, AI crop health, farmer aid"}
        />
      <meta
          name="keywords"  content={
          description ||
          "FarmerAid — AI-powered plant disease detection and crop care tips for farmers."
        }

      />
      <link rel="canonical" href={metaUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={metaUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={description || ""} />
      <meta name="twitter:image" content={metaImage} />

      {/* JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(schema || localBusinessSchema)}
      </script>

    </Helmet>
  );
}
